// Balances service: prioritize API, fallback to local mock store when available.
import { getFinalMockStore } from "./storeCreationService";

// Map storeType IDs to limit keys
const STORE_TYPE_MAP = {
  pf: "PF",
  mei: "MEI",
  me: "ME",
  epp: "EPP",
  emp: "EMP_EGP",
};

export async function fetchBalances() {
  // TODO: replace with real API call when backend is available, e.g.:
  // const res = await fetch('/api/store/balances');
  // if (!res.ok) throw new Error('Failed');
  // return await res.json();

  const local = getFinalMockStore();
  const storeType = local?.storeType || "pf";
  const limitKey = STORE_TYPE_MAP[storeType] || "PF";

  const base = {
    available: 573.32,
    retained: 244.98,
    totalWithdrawn: 4152.89,
    currentMonthTotal: 4726.21,
    withdrawals: [],
    currentLimitKey: limitKey, // pass to UI which one to highlight
    limits: {
      PF: 3000,
      MEI: 6500,
      ME: 30000,
      EPP: 420000,
      EMP_EGP: null, // unlimited
    },
  };
  if (local) {
    base.available = Math.round(Math.random() * 900) + 100;
    base.currentMonthTotal = base.available + Math.round(Math.random() * 3000);
  }
  return base;
}
